import ViewBase from "../../../../framework/core/mvvm/view_base";


const { ccclass, property } = cc._decorator;

@ccclass
export default class SettingView extends ViewBase {

    @property(cc.Button)
    closeBtn: cc.Button = null


    @property(cc.Toggle)
    musicToggle: cc.Toggle = null

    @property(cc.Toggle)
    soundToggle: cc.Toggle = null

    @property(cc.Slider)
    musicSlider: cc.Slider = null

    @property(cc.ProgressBar)
    musicProgressBar: cc.ProgressBar = null

    @property(cc.Slider)
    soundSlider: cc.Slider = null

    @property(cc.ProgressBar)
    soundProgressBar: cc.ProgressBar = null

    @property(cc.Label)
    labVersion: cc.Label = null;

    @property(cc.Label)
    nameTxt: cc.Label = null;

    // @property(cc.Label)
    // bindingCellphone: cc.Label = null;

    // @property(cc.Node)
    // openBinding: cc.Node = null;

    @property(cc.Node)
    btnSure = null;

    @property(cc.Label)
    labGameServerCenterVersion: cc.Label = null;
}
